

import { Home } from '@mui/icons-material';
import { t } from 'i18next';
import React from 'react';
import { Button, Alert } from 'react-bootstrap'; // Using react-bootstrap for styling (optional)

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
    this.setState({ hasError: true });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <Alert variant="danger" className="text-center" style={{ maxWidth: "400px", width: "100%" }}>
            <h3>{t("Oops! Something went wrong.")}</h3>
            <p>
              {t("It looks like something didn't work as expected. Please try again later or contact support if the issue persists.")}
            </p>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <Button variant="primary" color="primary" onClick={this.handleRetry}>
                {t("Try Again")}
              </Button>
            </div>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;